import React, {useCallback, useMemo} from 'react';
import {useParams} from 'react-router-dom';
import {ScheduleCalendarType} from '../../services';
import {useGotoSchedule} from './hooks';
import {Schedule} from './Schedule';

export const ScheduleScene: React.FC = () => {
  const {id, type, date} = useParams<{
    id: string;
    type: ScheduleCalendarType;
    date: string;
  }>();
  const gotoSchedule = useGotoSchedule();

  const handleChanged = useCallback(
    (nextDate: Date, nextCalendarType: ScheduleCalendarType) => {
      gotoSchedule(parseInt(id), nextCalendarType, nextDate);
    },
    [gotoSchedule, id],
  );

  const selectedDate = useMemo(() => new Date(date), [date]);

  return (
    <Schedule
      teamId={parseInt(id)}
      selectedDate={selectedDate}
      calendarType={type}
      onChange={handleChanged}
    />
  );
};

export * from './hooks';
